import { useEffect } from 'react';

const SITE_URL = 'https://lacapillahotel.com';

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href, attrs = {}) {
  let selector = `link[rel="${rel}"]`;
  if (attrs.hreflang) selector += `[hreflang="${attrs.hreflang}"]`;

  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
}

function setJsonLd(data) {
  const id = 'seo-jsonld';
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.id = id;
    el.type = 'application/ld+json';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

/**
 * @param {Object} opts
 * @param {string} opts.title
 * @param {string} opts.description
 * @param {string} opts.path        - e.g. '/boutique'
 * @param {string} opts.lang        - current i18n language code
 * @param {string} [opts.image]     - absolute URL to OG image
 * @param {Object} [opts.jsonLd]    - structured data object
 */
export default function usePageSEO({ title, description, path = '/', lang = 'es', image, jsonLd }) {
  useEffect(() => {
    const fullUrl = `${SITE_URL}${path}`;
    const ogImage = image || `${SITE_URL}/og-image.jpg`;

    // Title
    document.title = title;

    // Lang
    document.documentElement.lang = lang;

    // Basic meta
    setMeta('name', 'description', description);

    // Open Graph
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', fullUrl);
    setMeta('property', 'og:image', ogImage);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', 'Hotel La Capilla');
    setMeta('property', 'og:locale', lang === 'es' ? 'es_MX' : lang === 'en' ? 'en_US' : lang === 'de' ? 'de_DE' : 'fr_FR');

    // Twitter
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', ogImage);

    // Canonical
    setLink('canonical', fullUrl);

    // Hreflang alternates
    ['es', 'en', 'de', 'fr'].forEach(l => {
      setLink('alternate', fullUrl, { hreflang: l });
    });
    setLink('alternate', fullUrl, { hreflang: 'x-default' });

    // JSON-LD
    if (jsonLd) setJsonLd(jsonLd);

  }, [title, description, path, lang, image, jsonLd]);
}
